import { render, staticRenderFns } from "./admin_ssdj.vue?vue&type=template&id=29d0132a&scoped=true"
import script from "./admin_ssdj.vue?vue&type=script&lang=js"
export * from "./admin_ssdj.vue?vue&type=script&lang=js"
import style0 from "./admin_ssdj.vue?vue&type=style&index=0&id=29d0132a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d0132a",
  null
  
)

export default component.exports